module.exports = __webpack_public_path__ + "static/img/top-img-item.bafa492.jpg";